import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ChevronCircleDownSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12zm14.28-1.175l-1.286-1.286L12 12.533 9.006 9.539l-1.285 1.286L12 15.104l4.28-4.28z", fill: "currentColor" })] })));
};

export { ChevronCircleDownSolidIcon };
//# sourceMappingURL=ChevronCircleDownSolidIcon.js.map
